export default __webpack_public_path__ + "static/media/hht2_ep14_speaking_03.609352d8.png";